export const IS_ONLINE_SET = 'IS_ONLINE_SET';

export const setIsOnline = payload => ({
  type: IS_ONLINE_SET,
  payload
});
